export default "__VITE_ASSET__CNimWFBi__"